<div class="activate-account">
  <h3 class="text-center">Activate your account</h3>
  <p class="mb-0 text-center text-secondary">Please check your email in order to continue</p>
  <div class="d-flex align-items-center justify-content-center flex-column activate-account_email-img">
    <img src="/assets/img/pages/signup/email_travelgate.svg" alt="Email image" />
    <xen-alert
      type="info"
      content="<p class=&quot;mb-0&quot;>We have sent you an activation link to: <span class=&quot;fw-500&quot;>{{
        userEmail
      }}</span></p>"
    >
    </xen-alert>
  </div>
</div>
